import { Plural, Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import { BrandRequestMainContent } from '@/layouts/Brand/BrandRequestLayout/BrandRequestLayout';
import { RequestWithRelations } from '@/models/request';
import { ClientArticlesList } from '@/routes/Brand/Requests/Request/components/shared/ClientArticlesList';
import { useStoreToken } from '@/services/auth';

import { StepMessage } from './StepMessage';

export const ArchivedNone = ({ request }: { request: RequestWithRelations }) => {
  const storeToken = useStoreToken();

  return (
    <BrandRequestMainContent>
      <Stack gap="1rem">
        <Stack gap="0.25rem">
          <StepMessage
            message={
              <Trans id="client.request.archived-none.title">No service can be provided.</Trans>
            }
          />
          {storeToken && !!request.client ? (
            <StepMessage
              message={
                <Trans id="store.request.archived-none.message">
                  After analysis, we regret to inform you that no service can be provided for the{' '}
                  <Plural value={request.allArticles.length} one="item" other="items" />.
                </Trans>
              }
            />
          ) : (
            <StepMessage
              message={
                <Trans id="client.request.archived-none.message">
                  After analysis, we regret to inform you that no service can be provided for your{' '}
                  <Plural value={request.allArticles.length} one="item" other="items" />.
                </Trans>
              }
            />
          )}{' '}
        </Stack>
        <ClientArticlesList request={request} hideStepper showPrice={false} showArticleComment />
      </Stack>
    </BrandRequestMainContent>
  );
};
